module.exports = __webpack_public_path__ + "static/media/idea_mensch@2x.6db86aca.png";